export default function accessor(buf) {
    if (buf instanceof Uint8Array) {
        return {
            get(index) {
                return buf[index];
            },
            set(index, value) {
                buf[index] = value;
            }
        };
    }
    return {
        get(index) {
            return buf.get(index);
        },
        set(index, value) {
            buf.set(index, value);
        }
    };
}
